
export enum SoundNames {
    anticipator_leaves = "anticipator_leaves",
    anticipator_stars = "anticipator_stars",
    bigwin = "bigwin",
    collectionani = "collectionani",
    countuploop_trimmed = "countuploop_trimmed",
    explorerani_generic = "explorerani_generic",
    freespinsawarded = "freespinsawarded",
    jungleambience = "jungleambience",
    jungleambience_night = "jungleambience_night",
    megawin = "megawin",
    monkeysymbol = "monkeysymbol",
    reelland = "reelland",
    reelspin_normal = "reelspin_normal",
    reelspin_superturbo = "reelspin_superturbo",
    reelspin_turbo = "reelspin_turbo",
    royalsani_generic = "royalsani_generic",
    scatterland = "scatterland",
    supermegawin = "supermegawin",
    tigersymbolani_generic = "tigersymbolani_generic",
    tigertiger_bonusmusicloop = "tigertiger_bonusmusicloop",
    tigertiger_musicloop = "tigertiger_musicloop",
    uiclick = "uiclick",
    valuecollected = "valuecollected",
    winline = "winline",
    winmessage = "winmessage"
}
